export enum TenantGroups {
    UK = 'UK',
    UKSecure = 'UK (Secure)',
    Norway = 'Norway',
    NorwaySecure = 'Norway (Secure)',
    Sweden = 'Sweden',
    SwedenSecure = 'Sweden (Secure)',
    Denmark = 'Denmark',
    DenmarkSecure = 'Denmark (Secure)',
    Finland = 'Finland',
    FinlandSecure = 'Finland (Secure)',
    Sales = 'Sales',
    UKPS = 'UKPS',
    UKPSSecure = 'UKPS (Secure)',
    Product = 'Product',
    PartnerWSP = 'Partner - WSP',
    Master = 'Master',
    None = 'None',
}
